import React from 'react';
import {
    SkeletonBodyText,
    Page,
    PageActions,
    Card,
    Layout,
    ResourceItem,
    Badge,
    ResourceList,
    Button
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../common/Helpers';
import { Helmet } from 'react-helmet';

class ViewOperationPage extends React.Component {

    constructor(props) {
        super(props);

        const { params } = this.props.match;
        this.state = {
            id: params.id,
            isLoading: true,
            operation: {
            },
            runs: [],
            storeInfo: {}
        };
    }

    render() {

        var primary = { content: 'Edit', onAction: this.handleEdit };
        var secondary = { content: 'Execute', onAction: () => { this.handleRun(); } };

        if (this.state.operation.isExecuting) {
            secondary.isDisabled = true;
        }

        return (

            <div>
                <Helmet>
                    <title>Tag Genie - Edit Operation - {this.state.id}</title>
                </Helmet>
                {this.state.isLoading && <SkeletonBodyText lines="20" />}
                {!this.state.isLoading && <Page
                    // narrowWidth
                    title={"View Operation"}
                    primaryAction={primary}
                    secondaryActions={[secondary]}
                    breadcrumbs={[{ content: 'Operations', url: '/operations' }]}
                >
                    <Layout>
                        <Layout.Section>
                            <Card title="Description" sectioned>
                                <p>{this.state.operation.description}</p>
                            </Card>
                        </Layout.Section>
                        <Layout.Section>
                            <Card title="Last 10 runs" sectioned primaryFooterAction={secondary}>
                                <ResourceList
                                    resourceName={{ singular: 'run', plural: 'runs' }}
                                    items={this.state.runs}
                                    renderItem={this.renderRunItem}
                                />
                            </Card>
                        </Layout.Section>
                        <Layout.Section>
                            <Card title="Automation" sectioned>
                                {(this.state.storeInfo.tierName === "Free") && <p>Automations are only available on a paid plan.</p>}
                                {this.state.storeInfo.tierName !== "Free" && this.state.operation.automationId === null && <div>
                                    <Button onClick={this.onCreateAutomation}>Create automation</Button>
                                </div>}
                                {this.state.storeInfo.tierName !== "Free" && this.state.operation.automationId != null && <div>
                                    <Button onClick={this.onEditAutomation}>Edit automation</Button>
                                </div>}
                            </Card>
                        </Layout.Section>
                    </Layout>
                    <PageActions
                        secondaryActions={[
                            {
                                content: 'Delete',
                                onAction: this.handleDelete,
                                destructive: true,
                            },
                        ]}
                    />
                </Page>}
            </div>
        );
    }

    onEditAutomation = () => {
        this.props.history.push(`/automations/${this.state.operation.automationId}`);
    }

    onCreateAutomation = () => {
        this.props.history.push(`/automations/new?operationId=${this.state.operation.id}`);
    }

    handleDescriptionChange = (newValue) => {
        var operation = this.state.operation;
        operation.description = newValue;
        this.setState({ operation: operation });
    }

    handleDelete = () => {

        fetch(`api/operations/tag/${this.state.id}`, {
            method: 'DELETE'
        }).then(() => {
            this.props.history.push("/operations");
        });
    }

    handleEdit = () => {

        this.props.history.push(`/operations/${this.state.id}/edit`);
    }

    handleRun = () => {

        fetch(`api/operations/tag/${this.state.id}/run`, {
            method: 'POST',
        }).then(() => {
            this.fetchRuns();
        });
    }

    renderRunItem(item) {
        const { id, description, percentDone, runNumber, tagChanges, runTime } = item;
        const dateCreated = new Date(Date.parse(item.dateCreated));

        return (
            <ResourceItem id={id} url={null} onClick={(e) => { }}>
                <div>
                    <div className="operationItemContent">
                        <div className="operationItemContentColumn">
                            <span><b>#{runNumber}</b> - {dateCreated.toLocaleString()} - {tagChanges} tag changes</span>
                        </div>
                        <div className="operationItemContentRight">
                            {percentDone === 100 && <div>
                                <Badge status="success">Completed</Badge>
                            </div>}
                            {percentDone !== 100 && <div>
                                <Badge status="attention">Running - {Math.round(percentDone)}%</Badge>
                            </div>}
                        </div>
                        <div className="operationItemContentRightSmall">
                            {percentDone === 100 && <div>
                                <Badge>{runTime} min.</Badge>
                            </div>}
                        </div>
                    </div>
                    <span className="operationDescription">{description}</span>
                </div>
            </ResourceItem>
        );
    }

    componentDidMount() {
        fetch(`api/operations/tag/${this.state.id}/status`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {

                this.setState({
                    operation: data,
                    isLoading: false
                });
            });

        this.fetchRuns();
        this.getStoreInfo();
    }

    fetchRuns = () => {
        fetch(`api/operations/tag/${this.state.id}/runs`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                runs: data
            }));
    }

    getStoreInfo = () => {
        fetch(`api/storeConnections/info`, {
            method: 'GET',
        }).then(response => response.json())
            .then((data) => {
                this.setState({
                    storeInfo: data
                })
            });
    }
}

export default ViewOperationPage;